import type { PartialOnlyKeys } from "../types/common";
import type {
  IEngageableCampaign,
  InitialTargetSegmentItem,
  ITargetSegmentItem,
} from "../types/target-segment";

export const createTargetSegmentItem = (
  targetSegment: PartialOnlyKeys<ITargetSegmentItem, "engagedAt" | "properties">
): ITargetSegmentItem => {
  return {
    campaignId: targetSegment.campaignId,
    userId: targetSegment.userId,
    engageable: targetSegment.engageable,
    createdBy: targetSegment.createdBy,
    createdAt: targetSegment.createdAt,
    modifiedAt: targetSegment.modifiedAt ?? new Date().toISOString(),
    engagedAt: targetSegment.engagedAt ?? null,
    properties: targetSegment.properties ?? null,
  };
};

export const createInitialTargetSegmentItem = (
  initialTargetSegment: InitialTargetSegmentItem
): InitialTargetSegmentItem => {
  return {
    campaignId: initialTargetSegment.campaignId,
    userId: initialTargetSegment.userId,
    engageable: initialTargetSegment.engageable,
    createdBy: initialTargetSegment.createdBy,
    createdAt: initialTargetSegment.createdAt,
    modifiedAt: initialTargetSegment.modifiedAt,
    properties: initialTargetSegment.properties,
  };
};

export const findEnagageableCampaign = (
  engageableCampaigns: IEngageableCampaign[],
  campaignId: string
) => {
  return engageableCampaigns.find(
    (engageableCampaign) => engageableCampaign.campaignId === campaignId
  );
};
